module.exports = __webpack_public_path__ + "img/0-15.43d2a93a.gif";